const validateLuhn = (value) => {
  if (!value) return false;
  // Remove any non-digit characters just in case
  const digits = value.replace(/\D/g, '');
  
  let sum = 0;
  let shouldDouble = false;

  // Loop through digits from right to left
  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits.charAt(i));

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9; // Same as adding digits (e.g., 16 -> 1+6=7)
    }

    sum += digit;
    shouldDouble = !shouldDouble; // Alternate doubling
  }

  return sum % 10 === 0; // Valid if divisible by 10
};

const validateExpiryDate = (value) => {
  if (!value) return false;

  // Handle both raw digits "0525" and formatted "05/25"
  const formatted = value.includes('/') ? value : value.replace(/(\d{2})(\d{2})/, '$1/$2');

  if (!/^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(formatted)) return false;

  const [month, year] = formatted.split('/').map(Number);
  const now = new Date();
  const currentYear = parseInt(now.getFullYear().toString().slice(-2));
  const currentMonth = now.getMonth() + 1;

  if (year < currentYear) return false;
  if (year === currentYear && month < currentMonth) return false;

  return true;
};


export { validateLuhn, validateExpiryDate };